module.exports = __webpack_public_path__ + "static/media/sf-trial-1.25c8e290.mp3";